import { createFileRoute } from "@tanstack/react-router"
import { VersionInfoCard } from "./-VersionInfoCard"

export const Route = createFileRoute("/version/")({
  component: VersionInfoCard,
})
